// https://github.com/dcastil/tailwind-merge/blob/v2.0.0/docs/features.md
import { twJoin as tj, extendTailwindMerge } from 'tailwind-merge';
// eslint-disable-next-line @typescript-eslint/no-var-requires
import twTheme from '@shared/utils/theme';

export const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': Object.keys(twTheme.fontSize).map(key => `text-${key}`),
    },
  },
});

export const twJoin = tj;
